<script setup>
import { useSeoMeta } from '@unhead/vue'
import { useGlobalStore } from '@stores/global'
import InfiniteGallery from '@sections/lost-art/InfiniteGallery.vue'
import Loading from '@components/global/Loading.vue'

const global = useGlobalStore()

useSeoMeta({
	title: () => global.pages.find((page) => page.path === 'lost-art')?.title ?? global.pages.find((page) => page.path === '/')?.title,
	description: () => global.pages.find((page) => page.path === 'lost-art')?.description ?? global.pages.find((page) => page.path === '/')?.description,
	image: () => global.pages.find((page) => page.path === 'lost-art')?.image ?? global.pages.find((page) => page.path === '/')?.image,
})
</script>

<template>
	<Loading v-if="global.relics.length === 0" />
	<InfiniteGallery v-else />
</template>
